/**
 * Created by Jerker Nord on 2018-06-26.
 */

import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";

export class IceIceYetiReelSymbolStateCreator extends ReelSymbolStateCreator {

    constructor() {
        super();
    }

    protected noWinStateCreator(symbol:StateReelSymbol, stateKey:string, stateConfig:ISymbolStateConfig):TimelineSprite | null {
        const stateAnimation:TimelineSprite | null = this.getBasicStateAnimation(symbol, stateKey, stateConfig);
        if(stateAnimation) {
            stateAnimation.tint = 0x999999;
        }
        return stateAnimation;
    }

    protected getBasicStateAnimation(symbol:StateReelSymbol, stateKey:string, stateConfig:ISymbolStateConfig):TimelineSprite | null {
        if(stateConfig.symbols && stateConfig.symbols.indexOf(symbol.symName) === -1) {
            return null;
        }

        if(!stateConfig.texturesCreator) {
            stateConfig.texturesCreator = (symName:string, stateKey:string):PIXI.Texture[] => ReelSymbolStateCreator.defaultSymbolStateTexturesCreator(symName, stateKey);
        }

        const textures = stateConfig.texturesCreator(symbol.symName, stateKey);
        if(textures == null || textures.length === 0) {
            return null;
        }

        const sprite:TimelineSprite = new TimelineSprite(textures);

        if(stateConfig.scaleGetter) {
            const scale:[number, number] = stateConfig.scaleGetter(symbol.symName, stateKey);
            sprite.scale.set(scale[0], scale[1]);
        }

        sprite.anchor.set(0.5, 0.5);

        if(stateConfig.offsetGetter) {
            const offset:[number, number] = stateConfig.offsetGetter(symbol.symName, stateKey);
            sprite.position.set(offset[0], offset[1]);
        }
        return sprite;
    }
}